var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center gap-2.5 rounded-sm px-1.5 py-[3px] text-[9px] font-medium leading-none",class:[`label-${_vm.color}`]},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }